export const LOGIN_STARTED = "LOGIN_STARTED";
export const LOGIN_SUCCEDEED = "LOGIN_SUCCEDEED";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const VALIDATE_OTP_STARTED = "VALIDATE_OTP_STARTED";
export const VALIDATE_OTP_SUCCEDEED = "VALIDATE_OTP_SUCCEDEED";
export const VALIDATE_OTP_FAILED = "VALIDATE_OTP_FAILED";
// --- v2 types -- //
export const SEND_LOGIN_VALIDATION_TOKEN_STARTED = "SEND_LOGIN_VALIDATION_TOKEN_STARTED";
export const SEND_LOGIN_VALIDATION_TOKEN_SUCCEEDED = "SEND_LOGIN_VALIDATION_TOKEN_SUCCEEDED";
export const SEND_LOGIN_VALIDATION_TOKEN_FAILED = "SEND_LOGIN_VALIDATION_TOKEN_FAILED";
